// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-73188353]{margin-right:16px;margin-left:auto;color:#8f8f8f;font-size:14px}", ""]);
// Exports
module.exports = exports;
